var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block.content)?_c('div',{staticClass:"block-quote"},[_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.block.content.text)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.block.content.citation)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }